import { Form } from 'antd';
import useHasChanges from "./useHasChanges";
import useRequiredFieldsFilled from "./useRequiredFieldsFilled";


export default function ButtonSectionController({
  initialValues,
  children,
  closeModal,
}) {
  const values = {
    current_password: Form.useWatch(['current_password']),
    new_password: Form.useWatch(['new_password']),
    confirm_new_password: Form.useWatch(['confirm_new_password']),
  };
  const hasChanges = useHasChanges({ initialValues, values });
  const requiredFieldsFilled = useRequiredFieldsFilled(values);
  return children({
    props: {
      save: {
        disabled: !hasChanges || !requiredFieldsFilled,
      },
      popConfirm: {
        onConfirm: closeModal,
      },
      close: {
        onClick: closeModal,
      },
    },
    hasChanges,
  });
}